import Box from '@mui/material/Box'

const TextArea = ({
	placeholder = 'Type here...',
	value = '',
	onChange,
	sx = {},
	...rest
}) => {
	return (
		<Box
			component="textarea"
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			sx={{
				width: '100%',
				padding: '8px 12px',
				borderRadius: '8px',
				border: '1px solid #DFE4EB',
				fontFamily: 'Inter, sans-serif',
				fontSize: '14px',
				fontWeight: 500,
				color: '#313131',
				resize: 'none',
				boxSizing: 'border-box',
				maxHeight: '100px',
				minHeight: '100px',
				overflowY: 'auto',

				'&:focus': {
					outline: 'none',
					borderColor: '#7ca6bd',
				},

				'&::placeholder': {
					color: '#9AA4B3',
				},

				...sx, // Allow overriding from props
			}}
			{...rest}
		/>
	)
}

export default TextArea
